// @flow
import type { RecordFileType } from '../types/file';
import type { Action } from '../types/actions';
import recordFileService from '../services/record-file-service';
import resourceService from '../services/resource-service';

// action creators (not exported)
function filesRequest(): Action { return { type: 'GET_FILES_REQUEST' }; }
function filesSuccess(files): Action { return { type: 'GET_FILES_SUCCESS', files }; }
function filesError(error): Action { return { type: 'GET_FILES_ERROR', error }; }

function filesViewRequest(): Action { return { type: 'GET_FILE_VIEW_REQUEST' }; }
function filesViewSuccess(blob): Action { return { type: 'GET_FILE_VIEW_SUCCESS', blob }; }
function filesViewError(error): Action { return { type: 'GET_FILE_VIEW_ERROR', error }; }

function fileThumbnailRequest(): Action { return { type: 'GET_RESOURCE_THUMBNAIL_REQUEST' }; }
function fileThumbnailSuccess(file): Action { return { type: 'GET_RESOURCE_THUMBNAIL_SUCCESS', file }; }
function fileThumbnailError(error): Action { return { type: 'GET_RESOURCE_THUMBNAIL_FAILURE', error }; }

const fetchFiles = (id: Number) => (dispatch) => {
  dispatch(filesRequest());
  recordFileService
    .all(id)
    .then((files: RecordFileType[]) => {
      dispatch(filesSuccess(files));
    })
    .catch((error) => {
      dispatch(filesError(error));
    });
};

const viewFiles = (id: Number) => (dispatch) => {
  dispatch(filesViewRequest());
  recordFileService
    .view(id: number)
    .then((blob: Blob) => {
      dispatch(filesViewSuccess(blob));
    })
    .catch((error) => {
      dispatch(filesViewError(error));
    });
};

// for aggregated resources
const fetchFilesForResType = (type: string) => (dispatch) => {
  dispatch(filesRequest());
  resourceService
    .files(type)
    .then((files: RecordFileType[]) => {
      dispatch(filesSuccess(files));
    })
    .catch((err) => {
      dispatch(filesError(err));
    });
};

const fetchResourceFileThumb = (fileId: string) => (dispatch) => {
  dispatch(fileThumbnailRequest());
  recordFileService
    .viewThumbnail(fileId)
    .then((thumbnail: Blob) => {
      dispatch(fileThumbnailSuccess(thumbnail));
    })
    .catch((err) => {
      dispatch(fileThumbnailError(err));
    });
};


export { fetchFiles, viewFiles, fetchFilesForResType, fetchResourceFileThumb };


// WEBPACK FOOTER //
// ./src/actions/files.js